<template>
  <v-container id="delivery-report" fluid tag="section">

    <FilterForm 
      :filter-form="filterForm"
      :departmentList="departmentList"
      @click-search="search"
    />

    <DeliveryPeriod
        :periodReport="periodReport"
    />

    <DeliveryDay
        :dayReport="dayReport"
    />

    <Delivery
      :filter-form="filterForm" :dataTable="resPeriodReport"
    />

  </v-container>
</template>
<script>

import FilterForm from './components/FilterForm'
// import { formatDate } from '../../../../helpers/utils'
import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'
import * as ChartistTooltips from 'chartist-plugin-tooltips';

import RepositoryFactory from "@/repositories/RepositoryFactory";
import DeliveryPeriod from "./components/DeliveryPeriod";
import DeliveryDay from "./components/DeliveryDay";
import Delivery from "./components/Delivery";
import TokenService from "@/helpers/token";
const ReportRepository = RepositoryFactory.get('report');
const DepartmentRepository = RepositoryFactory.get('department')

export default {
  components: {
    Delivery,
    DeliveryDay,
    DeliveryPeriod,
    FilterForm,
  },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().startOf('month').format('YYYY-MM-DD'),
          endDate: moment().endOf('month').format('YYYY-MM-DD'),
        },
        departmentIds: []
      },
      periodReport: {

      },
      resPeriodReport: {
        dataDelivery: {
          'Giao thành công': 0,
          'Đang giao hàng': 0,
          'Hoàn': 0
        },
        total: 0
      },
      dayReport: {},
      departmentList: []
    };
  },
  async mounted() {
    this.search();
    await this.fetchDepartmentList()
  },
  beforeDestroy () {
  },
  methods: {
    search (filterForm) {
      if(filterForm) {
        this.filterForm = filterForm
      }

      this.getReportByPeriod()
      this.getReportByDays()
      Bus.$emit('delivery-status-report-thpt', this.filterForm)
    },

    // Get data báo cáo theo khoảng thời gian ~ denitis
    async getReportByPeriod() {
      const loader = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        duration: this.filterForm.dateRange.duration,
        departmentIds: this.filterForm.departmentIds,
        departmentType: 'retail',
        schoolLevelIds: [2]
      };
      const responsePeriod = await ReportRepository.deliveryReportByPeriod(params)

      loader.hide()

      if (responsePeriod.success) {
        this.resPeriodReport = _.get(responsePeriod, 'data', {})
        const response = _.get(responsePeriod, 'data.dataDelivery', {})
        this.periodReport = {
          series: [],
          labels: [],
          deliveryName: [],
          totalData: 0,
          color: colorChart
        }
        if (response.length < 1) {
          return
        }

        this.periodReport.totalData = responsePeriod.length
        for (const prop in response) {
          let percent = (response[prop] / _.get(responsePeriod, 'data.total', 0) * 100).toFixed(0);
          this.periodReport.series.push({
            meta: prop + ' :',
            value: percent
          })
          this.periodReport.labels.push(percent.toString() + '%')
        }
        let statusGroup = _.get(responsePeriod, 'data.statusGroup', {})
        for (let [key, value] of Object.entries(statusGroup)) {
          this.periodReport.deliveryName.push({value, key})
        }
      }
    },

    // Get data Báo cáo theo ngày ~ turnover
    async getReportByDays() {
      const loader = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        duration: this.filterForm.dateRange.duration,
        departmentIds: this.filterForm.departmentIds,
        departmentType: 'retail',
        schoolLevelIds: [2]
      };
      const responseDay = await ReportRepository.deliveryReportByDays(params)

      loader.hide()

      if (responseDay.success) {
        const response = _.get(responseDay, 'data', {})
        this.dayReport = {
          labels: [],
          series: [],
          totalData: 0,
          statusDeliveries: [],
          color: colorChart
        };
        if(response.length < 1 ) {
          return
        }

        this.dayReport.totalData = response.length
        let statusGroup = response.statusGroup
        // let statusGroup = {
        //   11: "Giao thành công",
        //   16: "Đang giao hàng",
        //   27: "Hoàn"
        // }
        const map = [];
        response.orderGroup.forEach( (day, key) => {
          this.dayReport.labels.push(...Object.keys(day))
          Object.keys(day).map((k) => {
            Object.values(statusGroup).map((productValue, index) => {
              if (!map[index]) map[index] = [];
              let tooltip = {
                meta: productValue + ': ' + day[k][productValue] + ', Ngày: ' + Object.keys(day),
                value: ((day[k][productValue]/day[k].total)*100).toFixed(0),
              }
              map[index].push(tooltip);
            });
          })
        });

        for (let [key, value] of Object.entries(statusGroup)) {
          this.dayReport.statusDeliveries.push({value, key})
        }
        this.dayReport.series.push(...map)
      }
    },
    async fetchDepartmentList () {
      this.loading = this.$loading.show();

      const response = await DepartmentRepository.listUsers({
        keyword: '',
        status: 'active'
      })
      this.groupUsers = []
      if (response.error) {
      } else {
        let departmentList = _.get(response, 'data', []).filter(d => _.get(d, 'users', []).length > 0);
        if (!this.isManager()) {
          const dataUser = TokenService.getUser() || {};
          departmentList = departmentList.filter(d => d.id == dataUser.departmentId  || dataUser.listDepartmentIds.includes(parseInt(d.id)));
        }
        this.departmentList = departmentList;
        this.departmentList.forEach(department => {
          const { users = [] } = department
          if (users.length) {
            this.groupUsers.push({
              header: department.name,
              name: _.get(department, 'name'),
              departmentId: department.id,
            })

            users.forEach(user => {
              this.groupUsers.push({
                name: _.get(user, 'fullName'),
                group: _.get(department, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                departmentId: department.id,
              })
            })
          }
        })
      }
      this.loading.hide()
    },
  }
};
</script>

<style lang="scss">
  #product-group-report {
    ul.description {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 10px 0;
      li {
        margin: 0 5px;
      }
    }
  }
</style>